import React from 'react';
import { useSelector } from 'react-redux';
import WizardNavigation from '../WizardNavigation';
import * as actions from '../../../store/actions/index';
import Aux from '../../../hoc/Aux';
import * as modalTypes from '../../Modals/modalTypes';
import ProductSystemItemsTables from '../../Shared/ProductSystemItemsTables';

const WizardStepProductSolutionsByUid = (props) => {

  if (props.currentStep !== 'product_solution_by_uid') {
    return null;
  }

  const isAuthenticated = useSelector(state => state.auth.token !== null);
  const productSystem = useSelector(state => state.wizard.selectedSteps.productSystem );
  const productSolutionItems = useSelector(state => state.wizard.sharedSolution.productSolutionItems );
  const holeForm = useSelector(state => state.wizard.sharedSolution.holeForm );
  const holeDiameter = useSelector(state => state.wizard.sharedSolution.holeDiameter );
  const holeHeight = useSelector(state => state.wizard.sharedSolution.holeHeight );
  const holeWidth = useSelector(state => state.wizard.sharedSolution.holeWidth );
  const selectedSteps = useSelector(state => state.wizard.selectedSteps );

  const calculator = {
    hole_form: holeForm,
    hole_diameter: holeDiameter,
    hole_width: holeWidth,
    hole_height: holeHeight,
  }

  const onSaveHandler = () => {
    return (isAuthenticated === true)? showSaveProductSystemItemsModalHandler : showCatchUnauthorizedSaveSolutionModalHandler;
  }

  const showSaveProductSystemItemsModalHandler = () => {
    return (items, calcData, calcResult) => {
      const modalProps = {open: true, formObject: {selectedSystemItems: items, calcData: calcData, calcResult: calcResult}};
      const modalType = modalTypes.MODAL_SAVE_PRODUCT_SYSTEM_ITEMS;
      return actions.showModal({ modalProps, modalType });
    }
  }

  const showCatchUnauthorizedSaveSolutionModalHandler = () => {
    return (items) => {
      const modalProps = {open: true, formObject: {selectedSystemItems: items}};
      const modalType = modalTypes.MODAL_CATCH_UNAUTHORIZED_SAVE_SOLUTION;
      return actions.showModal({ modalProps, modalType });
    }
  }


  console.log("CCC: ", selectedSteps)
  
  return(
    <Aux>
      <div className="row">
        <div className="col">
          <WizardNavigation />
        </div>
      </div>
      <ProductSystemItemsTables
        selectedSteps={selectedSteps}
        productSystem={productSystem}
        selectedItems={productSolutionItems}
        calculator={calculator}
        showModus='sharedUID'
        onSave={onSaveHandler()}/>
    </Aux>

 );
};

export default WizardStepProductSolutionsByUid;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepProductSystemItemsByUid.js